export const Footer = () => {
  return (
    <footer
      className="bg-[#02515A] texture-teal border-t border-[#FCF5EB]/10 py-16"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8">
        <p className="font-serif-display font-light text-xl text-[#FCF5EB]" data-testid="footer-wordmark">
          Goodbye <span className="italic">on Your Terms</span>
        </p>
        <a
          href="/podcast"
          className="text-xs tracking-[0.25em] uppercase text-[#FCF5EB]/60 hover:text-[#D9A441] transition-colors duration-300"
          data-testid="footer-podcast-link"
        >
          Goodbye Moon — The Podcast
        </a>
        <p className="text-xs tracking-[0.25em] uppercase text-[#FCF5EB]/60 text-center" data-testid="footer-worldwide-note">
          Serving clients worldwide — we travel to you
        </p>
        <p className="text-xs font-light text-[#FCF5EB]/40">
          By private inquiry only · {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};
